<template>
  <DefaultTransitionModal
    ref="modal-canceled"
    :textSecondaryBtn="$t('global.back')"
    :textPrimaryBtn="$t('salesOrder.action.confirm')"
    :hideStatusPreview="true"
    :entityData="entityData"
    :newStatusTransition="newStatusTransition"
    @transition="triggerSubmit"
  >
    <template #title>
      {{ $t('salesOrder.modal.transition.toCanceled.title') }}
    </template>
    <template #confirmationText>
      <div>
        <p
          v-if="selectedItems.length > 1"
          v-html="
            $t('salesOrder.modal.transition.toCanceled.content.itemMoreThanOne', {
              total: selectedItems.length,
            })
          "
        />
        <p
          v-else
          v-html="
            $t('salesOrder.modal.transition.toCanceled.content.one', {
              foNumber: selectedItems[0]?.number,
            })
          "
        />

        <FormulateForm
          v-model="formValues"
          name="reason-form"
          @submit="handleSubmit"
          @failed-validation="handleFailedValidation"
        >
          <FormulateInput
            class="p-0"
            type="text"
            name="canceled_reason"
            :label="$t('salesOrder.field.reasonForCancellation')"
            :placeholder="$t('salesOrder.placeholder.reasonForCancellation')"
          />
        </FormulateForm>
      </div>
    </template>
  </DefaultTransitionModal>
</template>

<script>
import DefaultTransitionModal from '@/components/McTransitionStatus/DefaultTransitionModal'

export default {
  components: {
    DefaultTransitionModal,
  },
  props: {
    entityData: {
      type: Object,
      required: true,
    },
    newStatusTransition: {
      type: Object,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
    }
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    handleSubmit(data) {
      this.$emit('transition', {
        transition: this.newStatusTransition,
        additionalPayload: {
          fields: {
            canceled_reason: data['canceled_reason'],
          },
        },
      })
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    // NOTE:
    // This function will be called from parents,
    // Ideally we capitalized the first letter of the function name
    // but the name are kept as 'show' and 'hide' to match bootstrap's convention
    // of modal 'show' and 'hide' function
    show() {
      this.$refs['modal-canceled'].show()
    },
    hide() {
      this.$refs['modal-canceled'].hide()
    },
  },
}
</script>
